import { useContext } from 'react';

import { DropdownContext } from './dropdown-context';

function useDropdown() {
  return useContext(DropdownContext);
}

export { useDropdown };
